"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSummaryDataV8 = exports.getSummaryData = exports.getBadgeFieldsV8 = exports.getBadgeFields = void 0;
const globals_1 = require("./constants/globals");
const getAdvancedBadgeFields = (badgeConfig) => {
    const { field, values = {} } = badgeConfig;
    if (Object.keys(values).length > 0) {
        return Object.entries(values).map(([key, value]) => ({
            field,
            value: key,
            label: typeof value === 'string' ? value : value === null || value === void 0 ? void 0 : value.label,
            color: value === null || value === void 0 ? void 0 : value.color
        }));
    }
    return { field, value: true };
};
/**
 * COMPATIBLE WITH V9 CONFIGS
 * I adapted this from pmc/api/helpers/providers.py badge_fields method.
 * Gets either the config badge_data or defaults and returns an array of the field strings
 * @param {object} config The config object to pull badges from.
 * @return {string[]} An array of badge strings.
 */
function getBadgeFields(config) {
    var _a;
    const badgeConfigs = ((_a = config.provider_v9) === null || _a === void 0 ? void 0 : _a.badge_data) || globals_1.DEFAULTS.BADGE_FIELDS;
    const result = badgeConfigs.flatMap((badgeConfig) => getAdvancedBadgeFields(badgeConfig));
    return result;
}
exports.getBadgeFields = getBadgeFields;
/**
 * COMPATIBLE WITH V8 CONFIGS
 * I adapted this from pmc/api/helpers/providers.py badge_fields method.
 * Gets either the config badge_data or defaults and returns an array of the field strings
 * @param {object} config The config object to pull badges from.
 * @return {string[]} An array of badge strings.
 */
function getBadgeFieldsV8(config) {
    var _a;
    const badgeConfigs = ((_a = config.provider) === null || _a === void 0 ? void 0 : _a.badge_data) || globals_1.DEFAULTS.BADGE_FIELDS;
    const result = badgeConfigs.flatMap((badgeConfig) => getAdvancedBadgeFields(badgeConfig));
    return result;
}
exports.getBadgeFieldsV8 = getBadgeFieldsV8;
/**
 * COMPATIBLE WITH V9 CONFIGS
 * I stole this from pmc/api/helpers/providers.py summary_configs method.
 * Gets either the config summary_data or the default
 * @param {object} config The config object to pull summary data from.
 * @return {object[]} An array of summary data objects.
 */
function getSummaryData(config) {
    var _a;
    return ((_a = config.search_results_page_v9) === null || _a === void 0 ? void 0 : _a.summary_data) || globals_1.DEFAULTS.SUMMARY_DATA;
}
exports.getSummaryData = getSummaryData;
/**
 * COMPATIBLE WITH V8 CONFIGS
 * I stole this from pmc/api/helpers/providers.py summary_configs method.
 * Gets either the config summary_data or the default
 * @param {object} config The config object to pull summary data from.
 * @return {object[]} An array of summary data objects.
 */
function getSummaryDataV8(config) {
    var _a;
    return ((_a = config.search_results_page) === null || _a === void 0 ? void 0 : _a.summary_data) || globals_1.DEFAULTS.SUMMARY_DATA;
}
exports.getSummaryDataV8 = getSummaryDataV8;
//# sourceMappingURL=config-utils.js.map